import styled from 'styled-components';

/**
 * The step's fields. Borderless: the "How often" section already frames them,
 * and a box inside a box read as two nested records.
 */
export const StepBox = styled.div`
  margin-bottom: ${(props) => props.theme.spacing(1)};
`;

/** The save preview, which sits outside the section and needs its own frame. */
export const PreviewBox = styled.div`
  border: 1px solid ${(props) => props.theme.palette.divider};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  padding: ${(props) => props.theme.spacing(1.5)};
  margin-bottom: ${(props) => props.theme.spacing(1)};
`;

/** The preview line itself. */
export const PreviewText = styled.p`
  margin: 0;
  font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  word-break: break-word;
`;

/**
 * Fields revealed by the checkbox or disclosure directly above them. Indented
 * with a left rule so it's visible which control they belong to — without it a
 * revealed block reads as another top-level row of the form.
 */
export const GatedBlock = styled.div`
  margin: 0 0 ${(props) => props.theme.spacing(1)};
  padding-left: ${(props) => props.theme.spacing(1.5)};
  border-left: 2px solid ${(props) => props.theme.palette.divider};
`;

/** Header for the collapsible extras. A button, so it's keyboard reachable. */
export const DisclosureButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(0.75)};
  width: auto;
  margin: 0 0 ${(props) => props.theme.spacing(1)};
  padding: ${(props) => props.theme.spacing(0.5)} 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: ${(props) => props.theme.palette.primary.main};
  font-family: inherit;
  font-size: ${(props) => props.theme.typography.body2.fontSize}px;
  text-align: left;

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.palette.primary.main};
    outline-offset: 2px;
  }
`;

/** The quiet "optional" qualifier beside the disclosure label. */
export const OptionalTag = styled.span`
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: ${(props) => props.theme.typography.caption.fontSize}px;
  font-weight: 400;
`;
